export default __webpack_public_path__ + "3a378c33d99c6e3cab8168ea5615b295.jpg";